module.exports = __webpack_public_path__ + "img/616.62f721fc.jpg";